import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './NLMDemoPage.css';

// Public, shareable training-journal view. Same data the demo page sidebar shows,
// just rendered as its own page so people can link to it without entering the demo flow.
function NLMLogPage() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/reading-brain/history')
      .then((r) => r.json())
      .then((d) => {
        setHistory(d.history || []);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="nlm-demo">
      <div
        className="nlm-demo-bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/hero-bg.png)` }}
      ></div>
      <div className="nlm-demo-overlay"></div>

      <main className="nlm-demo-main">
        <div className="nlm-demo-header">
          <div className="nlm-demo-badge">PUBLIC TRAINING JOURNAL &middot; NO FILTER</div>
          <h1>Reading Brain &mdash; Public Log</h1>
          <p className="nlm-demo-subtitle">
            Every question ever asked. Every answer ever given. Every miss preserved with a
            timestamp. We don&rsquo;t curate this. We don&rsquo;t clean it up. The misses are the
            point &mdash; they show what the model is still learning.
          </p>
          <p style={{ marginTop: '1.25rem' }}>
            <Link to="/nlm-demo" style={{
              display: 'inline-block',
              padding: '0.7rem 1.4rem',
              background: 'var(--gold, #c9a84c)',
              color: '#080808',
              borderRadius: '999px',
              textDecoration: 'none',
              fontWeight: 600,
              letterSpacing: '0.04em',
            }}>&larr; Back to Demo</Link>
          </p>
        </div>

        <div className="nlm-demo-notice">
          <h3>What you&rsquo;re reading</h3>
          <p>
            Each row is one query against the live Reading Brain. You see the question, the answer
            the model produced, and a timestamp. When the answer is right, the model is doing its
            job. When it&rsquo;s wrong, you see exactly how it got there.
          </p>
          <p>
            <strong>Why this is on the public web:</strong> if anyone calls this AI magical or
            invisible, this log is the answer. There&rsquo;s no curation layer between you and the model.
          </p>
        </div>

        <div style={{ marginTop: '2rem' }}>
          {loading && <p style={{ color: 'var(--text-sub, #a09484)' }}>Loading log…</p>}
          {error && <p style={{ color: '#e8835c' }}>Could not load log: {error}</p>}
          {!loading && !error && history.length === 0 && (
            <p style={{ color: 'var(--text-dim, #6b5f52)' }}>
              No queries logged yet. Be the first &mdash; head to the demo and ask something.
            </p>
          )}
          {!loading && history.length > 0 && (
            <div className="nlm-log-list">
              <p style={{ marginBottom: '1rem', color: 'var(--text-sub, #a09484)' }}>
                <strong>{history.length}</strong> {history.length === 1 ? 'query' : 'queries'} logged.
              </p>
              {history.map((h, i) => {
                return (
                  <article
                    key={i}
                    style={{
                      background: 'rgba(20, 17, 14, 0.7)',
                      border: '1px solid rgba(201, 168, 76, 0.18)',
                      borderRadius: '12px',
                      padding: '1.25rem',
                      marginBottom: '0.85rem',
                    }}
                  >
                    <div style={{ marginBottom: '0.5rem' }}>
                      <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.78rem', color: 'var(--text-dim, #6b5f52)' }}>
                        {h.timestamp}
                      </span>
                    </div>
                    <div style={{ marginBottom: '0.5rem' }}>
                      <strong style={{ color: 'var(--gold-light, #dbb867)' }}>Q:</strong>{' '}
                      <span style={{ color: 'var(--text, #ede8df)' }}>{h.question}</span>
                    </div>
                    <div>
                      <strong style={{ color: 'var(--gold-dim, #8a7235)' }}>A:</strong>{' '}
                      <span style={{ color: 'var(--text-sub, #a09484)' }}>{h.answer}</span>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default NLMLogPage;
